import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card/Card";
import CardActions from "@mui/material/CardActions";
import {styled} from "@mui/material";
import Stack from "@mui/material/Stack";


const SummaryCard = props => {
    const {title, avatarColor, AvatarIcon, children} = props;

    return (
        <Card>
            <Box sx={{
                pt: 4,
                px: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Typography variant="h4">
                    {title}
                </Typography>
                <Avatar sx={{width: 64, height: 64, backgroundColor: avatarColor}}>
                    <AvatarIcon sx={{fontSize: "2.0rem", color: '#fff'}}/>
                </Avatar>
            </Box>

            {children}
        </Card>
    )
};

export const SummaryCardStack = (props) => {
    const {children, size, ...stackProps} = props;

    return <Stack direction='column' alignItems='center' justifyContent='center' spacing={3} mb={2}
                  sx={{height: size === "small" ? "170px" : "250px"}}
                  {...stackProps}>
        {children}
    </Stack>
}

export const SummaryCardActions = styled(CardActions)({
    minHeight: "46px",
    display: "flex",
    justifyContent: "flex-end",
});


SummaryCard.propTypes = {
    title: PropTypes.string.isRequired,
    avatarColor: PropTypes.string.isRequired,
    AvatarIcon: PropTypes.object.isRequired,
    children: PropTypes.node,
};

export default SummaryCard;